import { useEffect } from 'react';

/**
 * Custom hook for preloading images using requestIdleCallback
 * Falls back to setTimeout if requestIdleCallback is not available
 */
export function useImagePreloader(imageSources: string[]) {
    useEffect(() => {
        const preloadImages = () => {
            imageSources.forEach((src) => {
                const img = new Image();
                img.src = src;
            });
        };

        if ('requestIdleCallback' in window) {
            requestIdleCallback(preloadImages, { timeout: 2000 });
        } else {
            setTimeout(preloadImages, 0);
        }
    }, [imageSources]);
}

